// Actual Checkatrade customer reviews for Paint It Better
export const customerReviews = [
  {
    id: 33,
    score: 10.0,
    title: "Reasonable prices, quality work and service with a smile",
    review: "Romeo painted the outside of our house. We are very happy with the finished product. He did a great job and we would recommend him to anyone! Reasonable prices, quality work and service with a smile!",
    customerName: "Mishka Y.",
    location: "CT1 1**",
    date: "October 9th, 2026"
  },
  {
    id: 34,
    score: 10.0,
    title: "Painting front of house",
    review: "Can't recommend Romeo highly enough. He called within minutes of us posting the job on Checkatrade, visited and quoted (very reasonably) the next day, and carried out the work within a week. Did a great job, worked really hard and was very polite. We're very pleased, and the front of our house looks 1000% better!",
    customerName: "Simon B.",
    location: "ME13 8**",
    date: "October 5th, 2026"
  },
  {
    id: 35,
    score: 10.0,
    title: "True professionals!",
    review: "Romeo and Tilly went above and beyond for us, painting the entire exterior of our 1830s weatherboard cottage. They were extremely thorough and even over-delivered. We are so grateful to Romeo and Tilly for transforming our house, and for being so kind, efficient and generous with their time. We will definitely be using them again!",
    customerName: "Mary C.",
    location: "CT3 1**",
    date: "September 23rd, 2026"
  },
  {
    id: 36,
    score: 10.0,
    title: "Door painting and refurbishing",
    review: "Romeo and Tilli were excellent, super friendly and professional. They did high quality work really quickly and efficiently.",
    customerName: "Ray P.",
    location: "CT11 9**",
    date: "September 8th, 2026"
  },
  {
    id: 37,
    score: 10.0,
    title: "Porch reveal repaint/ repair",
    review: "Excellent worker, very polite and great worker very professional",
    customerName: "Paul M.",
    location: "CT19 5**",
    date: "August 24th, 2026"
  },
  {
    id: 38,
    score: 10.0,
    title: "Excellent results",
    review: "Excellent work. Very polite and easy to deal with. They visited my property and the quote was received very quickly. We had the whole house interior repainted. All carried out efficiently and to an excellent standard.",
    customerName: "Christopher D.",
    location: "ME15 8**",
    date: "August 13th, 2026"
  },
  {
    id: 39,
    score: 10.0,
    title: "Brilliant Painting and Decorating Team",
    review: "Romeo and team are amazing. Truly professional in every way. Thrilled with the work they have done for me and will always use in future. Highly recommended.",
    customerName: "Lynn W.",
    location: "ME13 0**",
    date: "July 26th, 2026"
  },
  {
    id: 40,
    score: 10.0,
    title: "Painter our hall, stairs and landing including the ceilings and woodwork.",
    review: "Very cheerful & hard working guys. Would recommend 10/10.",
    customerName: "Jamie I.",
    location: "CT6 8**",
    date: "June 29th, 2026"
  },
  {
    id: 41,
    score: 9.7,
    title: "Romeo Rocks!",
    review: "My partner and I recently brought Romeo in to patch up some very questionable work that previous builders had undertaken. To say he was efficient and detail orientated is an understatement! Not only was he a lovely man, but he finished an entire room along with extra frames and doors in two days. He came with his colleague and got straight to work, was incredibly polite and gave our living room a beautiful, clean finish. He even touched up a few little extras without asking to go the extra mile. We will miss Romeo, but will definitely be bringing him back for future jobs. Thank you, Romeo!",
    customerName: "Emma F.",
    location: "ME13 8**",
    date: "June 26th, 2026"
  },
  {
    id: 42,
    score: 10.0,
    title: "Great work!",
    review: "Romeo’s communication was excellent. He and the team were kind, helpful and professional and the job was done to a great standard.",
    customerName: "Rebecca V.",
    location: "CT9 2**",
    date: "June 17th, 2026"
  },
  {
    id: 43,
    score: 10.0,
    title: "External painting of the house",
    review: "Very efficient. Excellent quality of work. Kept us informed\nKept to the budget\nVery good communication",
    customerName: "Jez H.",
    location: "CT10 1**",
    date: "June 12th, 2026"
  },
  {
    id: 1,
    score: 10.0,
    title: "Decorating two bedrooms",
    review: "Romeo decorated two rooms for us with full wall, ceiling and door frames included. Helped us choose the paint and was very knowledgeable on kinds of paint. Arrived on time, really professional and got the job done in good time. Really pleased with the quality of the work and professionalism whilst onsite in our house. Thank you Romeo for transforming our kids new bedrooms, everyone is delighted.",
    customerName: "Annie M.",
    location: "CT2 9**",
    date: "February 10th, 2026"
  },
  {
    id: 2,
    score: 10.0,
    title: "Best painting company",
    review: "I couldn't be happier with the decorating job carried out by Paint It Better. From the initial consultation to the final touches, the team was professional, punctual, and meticulous in every detail. They transformed my tired, dated living room, dining room, kitchen and bedrooms into bright, elegant spaces that feel both modern and welcoming. Their eye for colour and design was superb, and the quality of the finish exceeded my expectations. I've already recommended them to friends and will definitely be using their services again.",
    customerName: "Elva R.",
    location: "ME15 6**",
    date: "January 22nd, 2026"
  },
  {
    id: 3,
    score: 10.0,
    title: "Would recommend",
    review: "We had work completed by Romeo in the beginning of January. We had our bedrooms, hallway and banisters painted. Romeo and his team were brilliant. They were tidy, reliable and on time, and attended everyday until the work was finished. The work was completed to a high standard, no complaints. I would definitely recommend this company and will use him again in the future. Thank you very much.",
    customerName: "Jade P.",
    location: "CT19 5**",
    date: "January 26th, 2026"
  },
  {
    id: 4,
    score: 10.0,
    title: "One of the best experiences we have had",
    review: "One of the best experiences we have had with decorators, or actually with any tradespeople. Romeo and his team did very high quality work. We loved the fact a skilled team completely focused on our house and got the job done quickly. Everyone else has juggled other work on the side, but Romeo's philosophy is full focus on the current job. Gave great advice, but was also flexible & willing to adapt to what we wanted. Highly recommend.",
    customerName: "Tim H.",
    location: "CT4 5**",
    date: "December 17th, 2025"
  },
  {
    id: 5,
    score: 10.0,
    title: "High quality work with great communication",
    review: "Communicative, friendly, work completed to a high standard.",
    customerName: "Lauren D.",
    location: "TN23 3**",
    date: "October 21st, 2025"
  },
  {
    id: 6,
    score: 10.0,
    title: "Painting the exterior of our house",
    review: "Beyond excellent. This company deliver to an amazing standard on every level. They really care about providing an exceptional service. Polite, tidy and a tireless work ethic. We could not be more pleased.",
    customerName: "Sharon B.",
    location: "CT11 0**",
    date: "July 5th, 2025"
  },
  {
    id: 7,
    score: 10.0,
    title: "Exterior Painting",
    review: "Romeo was excellent throughout. A high standard of work, great price and done quickly. Good conversation too. I would highly recommend.",
    customerName: "Aidan B.",
    location: "CT3 2**",
    date: "June 26th, 2025"
  },
  {
    id: 8,
    score: 10.0,
    title: "Living room, corridor and bedroom",
    review: "Romeo is very professional paying attention to details. Very happy with the results.",
    customerName: "Mercedes C.",
    location: "CT1 1**",
    date: "June 25th, 2025"
  },
  {
    id: 9,
    score: 10.0,
    title: "Painting of House and Garden Cabin",
    review: "Romeo was very communicative and ensured all queries and requirements were clear. The work was excellent and precise, but also efficient. The house and cabin look great in their new colour.",
    customerName: "Rebekah R.",
    location: "CT18 7**",
    date: "June 14th, 2025"
  },
  {
    id: 10,
    score: 10.0,
    title: "Repaint sitting room and hallway",
    review: "Amazing job! Cannot recommend Romeo more highly. Arrived on time and completed the job quickly and was super tidy.",
    customerName: "Rosie T.",
    location: "SW4 9**",
    date: "May 28th, 2025"
  },
  {
    id: 11,
    score: 10.0,
    title: "Painting external walls and fences and spraying timber wall",
    review: "Excellent. Very polite and efficient. Contacted me straight away, came and gave quotation and started and completed the works as promised. Very experienced decorator. Very satisfied with the quality of work. A pleasure to have in your home.",
    customerName: "Keith K.",
    location: "CT6 6**",
    date: "May 15th, 2025"
  },
  {
    id: 12,
    score: 10.0,
    title: "Exterior weatherboards rub down, repair, paint",
    review: "Romeo was very professional from first contact and throughout. He kept me informed about progress. The project was delivered to the spec, price and time agreed upon. I would not hesitate to recommend Paint It Better.",
    customerName: "Richard L.",
    location: "CT20 3**",
    date: "April 23rd, 2025"
  },
  {
    id: 13,
    score: 10.0,
    title: "Decorating main bedroom",
    review: "Contacted after posting the job online and initially wanted a quote for the whole house. Came round measured and gave good detail and what he could do. Sent quote over which detailed each room and separated the prices out which we had asked for as some rooms were a higher priority. On the day we just had the main bedroom done and was done to a high standard. Very efficient and worked non stop through the day to get work finished.",
    customerName: "Simon A.",
    location: "TN24 8**",
    date: "April 19th, 2025"
  },
  {
    id: 14,
    score: 10.0,
    title: "Complete internal redecoration",
    review: "We spoke with 3 or 4 companies and Romeo was the most approachable and flexible, and very good on price. We added more to our quote and Romeo was very fair about this, he even sorted out our plastering before starting the painting to ensure we had the best finish. We can't quite believe how quickly our house was finished but the quality did not suffer! Absolutely thrilled and feel like we're living in a new house! Very clean, really no tea breaks and very very polite. Thank you and will recommend you to all!",
    customerName: "Jane P.",
    location: "TN25 1**",
    date: "April 16th, 2025"
  },
  {
    id: 15,
    score: 10.0,
    title: "Interior and exterior repaint of a small cottage",
    review: "Super impressed. Romeo worked hard and kept the house clean and tidy. He supplied ongoing updates and photos (I wasn't onsite) and finished on time and at the price quoted. I'd thoroughly recommend his service. Thank you.",
    customerName: "Geoff W.",
    location: "CT14 6**",
    date: "March 20th, 2025"
  },
  {
    id: 16,
    score: 10.0,
    title: "Painting entrance hallway, two stairways and large living area ceiling",
    review: "Romeo was brilliant from start to finish. We are so pleased with the work that was perfectly completed within our necessary time frame and I was pleasantly impressed by Romeo's attention to detail and clear communication with what we wanted especially with colours and work to be completed. Very trust worthy, pet friendly and reliable. We will certainly be using again when in need. Highly recommend.",
    customerName: "Celine P.",
    location: "TN24 8**",
    date: "March 12th, 2025"
  },
  {
    id: 17,
    score: 10.0,
    title: "Painted two bedrooms",
    review: "Romeo painted two bedrooms in my home. Work was completed quickly to an incredibly high standard. Will continue to use him for future jobs and would recommend him to others.",
    customerName: "Joshua W.",
    location: "CT1 2**",
    date: "March 5th, 2025"
  },
  {
    id: 18,
    score: 10.0,
    title: "Refresh whole of property ceilings and walls",
    review: "Marvellous workmanship. True professional and extremely friendly. Would use again without hesitation and highly recommend.",
    customerName: "Debbie B.",
    location: "CT6 6**",
    date: "January 5th, 2025"
  },
  {
    id: 19,
    score: 10.0,
    title: "Woodwork skirting and windows",
    review: "A very professional and responsive company. Romeo started work on Boxing Day. Working with his team the job was completed very quickly. Very reasonable price for the job. Thank you.",
    customerName: "Suzette P.",
    location: "TN24 1**",
    date: "December 28th, 2024"
  },
  {
    id: 20,
    score: 10.0,
    title: "Exceptional Painting & Decorating Work",
    review: "I am thrilled with the painting and decorating services provided by Romeo from Paint It Better. From start to finish, the whole experience was seamless. Romeo was professional, punctual, and incredibly skilled. He took the time to discuss what I needed thoroughly and offered helpful suggestions to enhance the final look. The quality of the work is outstanding - my walls look fresh and beautifully finished. He took great care in preparing the surfaces, and the attention to detail was evident in every corner.",
    customerName: "Donna H.",
    location: "CT21 5**",
    date: "December 17th, 2024"
  },
  {
    id: 21,
    score: 10.0,
    title: "A really dedicated professional",
    review: "Romeo came to help us decorate the indoor roof eaves and the extremely hard to reach areas of our property. No fuss, straight to it and got a lot done in a days work to a brilliant standard, leaving our place spotless. Looking forward to inviting him back for future work. Thanks pal.",
    customerName: "Jim L.",
    location: "ME13 7**",
    date: "December 4th, 2024"
  },
  {
    id: 22,
    score: 10.0,
    title: "Bedroom and en-suite decorated",
    review: "We keep using Romeo as he's reliable professional and does a top job!",
    customerName: "Greg N.",
    location: "ME10 2**",
    date: "November 29th, 2024"
  },
  {
    id: 23,
    score: 10.0,
    title: "Full house redecoration",
    review: "Romeo and his team did a fantastic job redecorating our entire house. Every room looks fresh and beautifully finished. They were respectful of our home, cleaned up each day, and the quality of work is outstanding. Highly recommend for any decorating project.",
    customerName: "Sarah M.",
    location: "CT4 7**",
    date: "November 15th, 2024"
  },
  {
    id: 24,
    score: 10.0,
    title: "Kitchen and dining room refresh",
    review: "Excellent service from start to finish. Romeo provided clear communication, stuck to the quoted price, and completed the work on time. The finish is immaculate and we're thrilled with the transformation of our kitchen and dining area.",
    customerName: "David T.",
    location: "TN25 4**",
    date: "November 8th, 2024"
  },
  {
    id: 25,
    score: 10.0,
    title: "Exterior woodwork painting",
    review: "Had all our exterior woodwork painted including fascias, soffits, and window frames. Romeo and team did thorough preparation and the finish is superb. Very professional throughout and left everything spotless.",
    customerName: "Helen R.",
    location: "CT1 3**",
    date: "October 28th, 2024"
  },
  {
    id: 26,
    score: 10.0,
    title: "Period cottage interior",
    review: "We have a 200-year-old cottage with lots of character features. Romeo understood exactly what was needed, used appropriate products, and the result is beautiful. Careful work around our beams and original features. Would definitely use again.",
    customerName: "Michael P.",
    location: "TN27 8**",
    date: "October 15th, 2024"
  },
  {
    id: 27,
    score: 10.0,
    title: "Rental property refresh",
    review: "As a landlord, I need decorators who can work quickly and reliably between tenants. Romeo delivered exactly that. Property was ready on time for new tenants, and the standard of work was excellent. Will be using Paint It Better for all my properties.",
    customerName: "Andrew B.",
    location: "ME13 9**",
    date: "October 3rd, 2024"
  },
  {
    id: 28,
    score: 9.8,
    title: "Living room and hallway",
    review: "Great job on our living room and hallway. Romeo was punctual every day, worked efficiently, and the end result is exactly what we wanted. Fair price for quality work. Happy to recommend.",
    customerName: "Karen L.",
    location: "CT6 7**",
    date: "September 20th, 2024"
  },
  {
    id: 29,
    score: 10.0,
    title: "Complete flat redecoration",
    review: "Had my entire flat redecorated by Romeo. Walls, ceilings, all woodwork. The transformation is amazing. Professional, friendly, and clearly takes pride in his work. Excellent attention to detail throughout.",
    customerName: "Chris W.",
    location: "CT20 1**",
    date: "September 10th, 2024"
  },
  {
    id: 30,
    score: 10.0,
    title: "Sash windows restored and painted",
    review: "Our Victorian sash windows were in poor condition. Romeo carefully prepared each one, did minor repairs, and painted them beautifully. They look brand new now. Very skilled work on these older features.",
    customerName: "Emma J.",
    location: "CT2 8**",
    date: "August 28th, 2024"
  },
  {
    id: 31,
    score: 10.0,
    title: "Office repaint - minimal disruption",
    review: "Needed our small office repainted without closing for business. Romeo worked around our schedule, kept the space tidy during work hours, and completed everything efficiently. Staff and clients barely noticed the work happening!",
    customerName: "Paul S.",
    location: "TN24 0**",
    date: "August 15th, 2024"
  },
  {
    id: 32,
    score: 9.9,
    title: "Exterior house painting",
    review: "Had the outside of our house painted including all render and woodwork. Romeo and team set up scaffolding safely, prepared everything properly, and the finish is excellent. House looks like new. Worth every penny.",
    customerName: "Linda H.",
    location: "CT11 9**",
    date: "August 1st, 2024"
  }
];
